export default "__VITE_ASSET__BMurj4yK__"